import React from "react";
import { IFullPlanDetailPPO } from "../../../interfaces/api";
import SingleInfoBenefit from "./SingleInfoBenefit.component";

import PPODoubleInfoBenefit from "./PPODoubleInfoBenefit.component";
import {
  getDoubleDataPPO,
  getDoubleDeepPPO,
} from "../../../functions/planDetails";
import PPODoubleDeepInfoBenefit from "./PPODoubleDeepInfoBenefit.component";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const PPODataTableDetailExtra = ({ data }: { data: IFullPlanDetailPPO }) => {
  const { selectedYear } = useZipRootLoaderData();

  const one =
    selectedYear === 2024
      ? getDoubleDeepPPO(
          data,
          "Over-The-Counter (OTC)",
          "Over-the-Counter (OTC)"
        )
      : getDoubleDeepPPO(
          data,
          "Over-The-Counter (OTC)",
          "Over-The-Counter (OTC)"
        );
  const two =
    selectedYear === 2024
      ? getDoubleDeepPPO(
          data,
          "Support for Care Givers Of Enrollee",
          "Support for Caregivers of Enrollees"
        )
      : getDoubleDeepPPO(
          data,
          "Support for Care Givers Of Enrollee",
          "Support for Care Givers Of Enrollee"
        );
  const three = getDoubleDeepPPO(
    data,
    "Acupuncture And Reflexology",
    "Acupuncture (Medicare and Routine)"
  );
  const four = getDoubleDataPPO(
    data,
    "Chiropractic Services (Medicare and Routine)"
  );
  const five = getDoubleDeepPPO(data, "Fitness", "Fitness Benefit");
  const six =
    selectedYear === 2024
      ? getDoubleDeepPPO(
          data,
          "Doctor visits",
          "Additional Telehealth Benefits"
        )
      : getDoubleDeepPPO(
          data,
          "Doctor visits",
          "Additional Telehealth Services"
        );
  const seven =
    selectedYear === 2024
      ? getDoubleDeepPPO(
          data,
          "In-Home Support Services",
          "In-Home Support Services"
        )
      : getDoubleDeepPPO(
          data,
          "In-Home Support Services",
          "In-Home Support Services"
        );

  const nine = getDoubleDeepPPO(
    data,
    "Worldwide Emergency/ Urgent Coverage",
    "Worldwide Emergency/Urgent Coverage"
  );
  const ten = getDoubleDataPPO(data, "Durable Medical Equipment (DME)");

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",

        textAlign: "left",
      }}
    >
      {" "}
      <SingleInfoBenefit
        benefit={[
          {
            pbpBenefitDesc: " $0",
            pbpBenefitName: null,
            vendorDetails: null,
          },
        ]}
        title="24/7 Concierge Service"
      />
      <div
        className="grid-x hide-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        ></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
            paddingLeft: 20,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div className="cell small-4"></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <PPODoubleDeepInfoBenefit
        benefit={one}
        title="Over-the-counter (OTC) Allowance"
      />
      <PPODoubleDeepInfoBenefit benefit={two} title="Caregiver Support" />{" "}
      <PPODoubleDeepInfoBenefit benefit={three} title="Acupuncture" />{" "}
      <PPODoubleInfoBenefit benefit={four} title="Chiropractic Services" />{" "}
      <PPODoubleDeepInfoBenefit benefit={five} title="Fitness" />{" "}
      <PPODoubleDeepInfoBenefit benefit={six} title="Telehealth" />{" "}
      <PPODoubleDeepInfoBenefit benefit={seven} title="In-Home Support" />{" "}
      <PPODoubleDeepInfoBenefit
        benefit={nine}
        title="Worldwide Emergency / Urgent Coverage"
      />
      <PPODoubleInfoBenefit benefit={ten} title="Durable Medical Equipment" />
    </div>
  );
};

export default PPODataTableDetailExtra;
